import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequest = (data: any) => {
  return {
    approvalId: data.id, // 0
    approvalType: data.type, // 'DELETE_APPROVAL',
    status: data.status, // true/false
    type: 'PAYOUT_CONFIG',
  }
}

const merchantPayoutConfigProcessApprovals = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.processApprovalsOfMerchantPayout),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { merchantPayoutConfigProcessApprovals }
